// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"994":"63c7b384","2065":"6e71a563","2066":"6e71a563","2141":"addd8fc0","2287":"23aa892b","5507":"11e3e73c","5938":"63c7b384","7059":"80162652","7921":"95c391d4","7992":"3c141033","8693":"28a1cf20"}[chunkId] + ".chunk.css";
};